<template>
  <v-hover v-slot="{ hover }" close-delay="200">
    <v-card
      :elevation="hover ? 10 : 0"
      :class="{ 'on-hover': hover }"
      class="mx-auto Account-card"
      style="background: #FFFFFF;
             height: 68px;
             border: 1px solid #ECECEC;
            box-sizing: border-box;
            box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
            border-radius: 10px;   
"
    >
      <a href="javascript:void(0)" @click="$router.push({ path: cardPath })">
        <b-row>
          <b-col md="12" class="ml-2" style="margin-top:20px; margin-left:4px;">
            <h4
              style="color:#737CF4; font-size:18px ;margin-top:20px;"
              class="m-1"
            >
              {{ cardName }}
              <i
                class=" icon fas fa-angle-right"
                style="color:#737CF4; font-size:18px; float: right; margin-right: 10px; margin-top: 0px !important"
              ></i>
            </h4>
          </b-col>
          <!-- <b-col md="1">
            <i
              class=" icon fas fa-angle-right"
              style="color:#737CF4; font-size:18px ; margin-top:20px;"
            ></i
          ></b-col> -->
        </b-row>
      </a>
    </v-card>
  </v-hover>
</template>
<script>
export default {
  name: "cardView",
  props: ["cardName", "cardPath"]
};
</script>
